export const UPLOAD_QUOTES_STEPS = ['Subir plantilla', 'Resumen'];